import React, { forwardRef } from 'react';
import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import styles from './styles';

const Input = forwardRef(
  ({ control, name, onChange, inputRef, ...props }, ref) => {
    if (control) {
      return (
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <TextField
              fullWidth
              {...field}
              {...props}
              name={name}
              autoComplete="off"
              variant="outlined"
              FormHelperTextProps={{ sx: styles.helperText }}
              sx={styles.textField}
              size="small"
              inputRef={inputRef || ref}
              onChange={(e) => {
                field.onChange(e);
                onChange?.(e);
              }}
            />
          )}
        />
      );
    }

    return (
      <TextField
        fullWidth
        {...props}
        name={name}
        autoComplete="off"
        variant="outlined"
        FormHelperTextProps={{ sx: styles.helperText }}
        sx={styles.textField}
        size="small"
        inputRef={inputRef || ref}
        onChange={onChange}
      />
    );
  }
);

export default Input;
